import React, { useState } from 'react'
import api from '../../lib/api.interceptor'
// import { useNavigate } from "react-router";
// import { ChannelPartnerInquiry } from '../../lib/ChannelPartnerInquiry'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setThankYouData } from '../../store/features/projectSlice'
import { useRouter } from 'next/navigation'
import { Toast } from './Toast'

function Contact_form({ countryList, departmentList }) {
  const router = useRouter()
  const dispatch = useDispatch()
  // const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    contact_no_display: '',
    contact_no: '',
    email: '',
    from_app: 'true',
    master_user_id: '239',
    logged_in_master_user_id: '239',
    department: '',
    message: '',
    flag: 'https://flagcdn.com/w40/in.webp',
    country: '91'
  })

  const [search, setSearch] = useState('')
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState({})

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    })
  }

  const handlePhoneKeyDown = (e) => {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Delete'
    ]
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault()
    }
  }

  const handleCountrySelect = (phonecode, flag) => {
    setFormData({ ...formData, country: phonecode, flag })
    setDropdownOpen(false)
  }

  const validate = () => {
    const newErrors = {}
    if (!formData.name.trim()) newErrors.name = 'Name is required.'
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.'
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Enter a valid email.'
    }
    if (!formData.contact_no_display.trim()) {
      newErrors.contact_no_display = 'Mobile number is required.'
    } else if (!/^[0-9]{10,15}$/.test(formData.contact_no_display.trim())) {
      newErrors.contact_no_display = 'Enter a valid mobile number.'
    }
    if (!formData.department) newErrors.department = 'Department is required.'
    if (!formData.message.trim()) newErrors.message = 'Comment is required.'

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return
    setIsSubmitting(true)

    formData.contact_no = formData.country + ' ' + formData.contact_no_display
    // console.log('Submit Data:', formData)
    const response = await api.ContactInquiry(formData)
    if (response.success == 1) {
      setIsSubmitting(false)
      setErrors({})
      // navigate(`/contact-us/thank_you`, {
      //   state: {
      //     page_name: 'Contact Us',
      //     document: []
      //   }
      // })

      dispatch(setThankYouData({ page_name: 'Contact Us', document: [] }))
      router.push('/contact-us/thankyou')

      Toast(response.message)
      setFormData({
        name: '',
        contact_no_display: '',
        contact_no: '',
        email: '',
        from_app: 'true',
        master_user_id: '373',
        logged_in_master_user_id: '373',
        department: '',
        message: '',
        flag: 'https://flagcdn.com/w40/in.webp',
        country: '91'
      })
    } else {
      setIsSubmitting(false)
      Toast(response.message)
    }
    // console.log(formData);
    // submit logic here
  }

  return (
    <>
      <div>
        <form
          id="contact"
          name="contact"
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <div className="form_wrapper contact_form">
            <div className="contact_lable">
              <input
                id="name"
                name="name"
                type="text"
                className={`form-control ${errors.name ? 'error' : ''}`}
                // required
                tabIndex="1"
                value={formData.name}
                onChange={handleChange}
              />
              <label className="md-lable" htmlFor="name">
                Name
              </label>
              {/* {errors.name && <div className="error">{errors.name}</div>} */}
            </div>

            <div className="contact_lable">
              <input
                id="email"
                name="email"
                type="email"
                className={`form-control ${errors.email ? 'error' : ''}`}
                // required
                autoComplete="off"
                tabIndex="2"
                value={formData.email}
                onChange={handleChange}
              />
              <label className="md-lable" htmlFor="email">
                Email
              </label>
              {/* {errors.email && <div className="error">{errors.email}</div>} */}
            </div>

            <div className="contact_lable relative">
              <input
                id="contact_no"
                name="contact_no_display"
                type="tel"
                className={`form-control contact-form ${
                  errors.contact_no_display ? 'error' : ''
                }`}
                // required
                autoComplete="off"
                tabIndex="3"
                minLength={10}
                maxLength={10}
                value={formData.contact_no_display}
                onChange={handleChange}
                onKeyDown={handlePhoneKeyDown}
              />
              <label className="md-lable" htmlFor="contact_no">
                Mobile Number
              </label>
              <div className="conatct_number_input">
                <div
                  className="country_code_data"
                  onClick={(e) => {
                    e.stopPropagation()
                    setDropdownOpen(!dropdownOpen)
                  }}
                >
                  <div className="contact_country_flag">
                    <img src={formData.flag} alt="flag" />
                  </div>
                  <div>&nbsp;+{formData.country}</div>
                  <div>
                    <span className="material-symbols-outlined">stat_minus_1</span>
                  </div>
                </div>
              </div>
              {dropdownOpen && (
                <div
                  className="country-overlay"
                  onClick={() => {
                    setDropdownOpen(false)
                  }}
                ></div>
              )}
              {dropdownOpen && (
                <div
                  className="country_code_list_data active"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="search_c-code">
                    <input
                      type="text"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <ul>
                    {countryList
                      ?.filter(
                        (c) =>
                          c.nicename
                            .toLowerCase()
                            .includes(search.toLowerCase()) ||
                          c.phonecode.includes(search)
                      )
                      .map((c, idx) => (
                        <li
                          key={idx}
                          onClick={() =>
                            handleCountrySelect(c.phonecode, c.flag)
                          }
                        >
                          <div>
                            <img src={c.flag} alt="flag" />
                            <span className="display_country_code">
                              +{c.phonecode}
                            </span>
                            {c.nicename}
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
              {/* {errors.contact_no_display && <div className="error">{errors.contact_no_display}</div>} */}
            </div>

            <div className="contact_lable select_option select_apr relative">
              <select
                name="department"
                className={`form-control ${errors.department ? 'error' : ''}`}
                id="department"
                tabIndex="4"
                value={formData.department}
                onChange={handleChange}
                // required
              >
                <option value="" disabled hidden></option>
                {departmentList?.map((dep, i) => (
                  <option key={i} value={dep.department} className="capitalize">
                    {dep.department}
                  </option>
                ))}
              </select>
              <label className="md-lable department_label" htmlFor="department">
                Department
              </label>
              <div className="fa-icon">
                <span className="material-symbols-outlined">stat_minus_1</span>
              </div>
              {/* {errors.department && <div className="error">{errors.department}</div>} */}
            </div>

            <div className="contact_lable commentbox">
              <textarea
                id="message"
                name="message"
                className={`form-control ${errors.message ? 'error' : ''}`}
                tabIndex="5"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                // required
              />
              <label className="md-lable" htmlFor="message">
                Comment
              </label>
              {/* {errors.message && <div className="error">{errors.message}</div>} */}
            </div>

            <p className="relative check_box_error get_update_text align_center">
              <input
                className="get_update_checkbox"
                type="checkbox"
                id="agree_tandc"
                name="agree_tandc"
                tabIndex="6"
                checked={formData.agree_tandc}
                onChange={handleChange}
              />
              <label className="darkgray-font" htmlFor="agree_tandc">
                Keep me updated.
              </label>
            </p>

            <div className="filled-div-button button-div">
              <button
                className="button-style black-btn"
                type="submit"
                tabIndex="7"
                disabled={isSubmitting}
              >
                {isSubmitting && <div className="loading_btn"></div>}
                <p>Submit</p>
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default Contact_form
